import { render, staticRenderFns } from "./NglViewer.vue?vue&type=template&id=79fb7d4c&scoped=true"
import script from "./NglViewer.vue?vue&type=script&lang=ts"
export * from "./NglViewer.vue?vue&type=script&lang=ts"
import style0 from "./NglViewer.vue?vue&type=style&index=0&id=79fb7d4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79fb7d4c",
  null
  
)

export default component.exports